/* * @Author: jingyu.yang * @Date: 2022-01-10 15:56:20 * @Last Modified by:
xiuhong.miao * @Last Modified time: 2024-06-24 13:41:35 */
<template>
  <div class="passwordLuckDraw" :data-i18n-locale="$i18n.locale" >
    <el-dialog ref="dialog" :visible="isShowPasswordLuck && !isInitDataing" :close-on-click-modal="false" class="dialog-dark password-luck"
      :title="$t('passwordLuckDraws.口令抽奖')" width="454px" @open="onOpen" @close="close">
      <el-form ref="passwordLuckDraw" :model="formLabelAlign" :rules="rules" :label-position="'right'" class="form-dark"
        size="mini" :label-width="labelWidth">

        <el-form-item :label="$t('passwordLuckDraws.抽奖标题')" prop="subject">
          <el-input
            ref="luckSubjectInput"
            v-model="formLabelAlign.subject"
            class="luck-subject"
            type="text"
            :placeholder="$t('luckDraws.请输入')"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('luckDraws.奖品名称')" prop="title">
          <el-popover :value="isFoucs" :effect="'dark'" trigger="manual" popper-class="tip-popconfirm luck-tip-popconfirm"
            placement="bottom" :title="$t('luckDraws.参考名称')">
            <el-input ref="input" v-model="formLabelAlign.title" slot="reference" class="luck-title" type="text"
              :placeholder="$t('luckDraws.请输入')" maxlength="30" show-word-limit @focus="isFoucs = true"
              @blur="isFoucs = false"></el-input>
            <div class="password-luck-fastbox">
              <div v-for="item in lucks" :key="item" @click="setFast($t(`luckDraws.${item}`))">
                {{ $t(`luckDraws.${item}`) }}
              </div>
            </div>
          </el-popover>
        </el-form-item>

        <el-form-item class="luck-num" :label="$t('luckDraws.中奖人数')" prop="raffleCount">
          <el-input
            v-model="formLabelAlign.raffleCount"
            type="number"
            :placeholder="$t('luckDraws.请输入')"
            onkeyup="value=value.replace(/[^\d]/g,'')"
            @blur="formLabelAlign.raffleCount = $event.target.value"
          ></el-input>
          <!-- <span class="luck-num-tip input-tip">
            <span class="luck-online">{{ $t("luckDraws.共") }}<span class="total-num">{{ total }}</span>{{$t("luckDraws.人") }}</span>,
            <span class="tip-content">{{$t("luckDraws.中奖人数不能超过参与用户人数")}}</span>
          </span> -->
        </el-form-item>
        <el-form-item class="luck-countdown is-required" prop="countdown" :label="$t('passwordLuckDraws.抽奖倒计时')">
          <div style="margin-bottom: 5px;">
            <el-switch v-model="formLabelAlign.autoDraw" :width="28" active-color="#2081EB" inactive-color="#5B617E"></el-switch>
          </div>
          <div v-if="formLabelAlign.autoDraw" >
          <el-input
            v-model="formLabelAlign.drawCountdownDateJson.minutes"
            type="number"
            placeholder="00"
            onkeyup="value=value.replace(/[^\d]/g,'')"
            @blur="formLabelAlign.drawCountdownDateJson.minutes = $event.target.value"
          ></el-input>
          <span class="colon">:</span>
          <el-input v-model="formLabelAlign.drawCountdownDateJson.seconds"
            type="number"
            placeholder="00"
            onkeyup="value=value.replace(/[^\d]/g,'')"
            @blur="formLabelAlign.drawCountdownDateJson.seconds = $event.target.value"
          ></el-input>
          <span class="luck-countdown-tip input-tip">
            <span class="tip-content">{{$t("passwordLuckDraws.输入范围：00:10 - 59:59")}}</span>
          </span>
        </div>
        </el-form-item>
        <!-- 奖品图片 -->
        <el-form-item :label="`${$t('passwordLuckDraws.奖品图片')}：`">
            <el-upload
              class="picture-card"
              list-type="picture-card"
              accept="image/png, image/jpeg, image/jpg"
              :show-file-list="false"
              :data="dataObj"
              :action="uploadUrl"
              :on-success="uploadSuccess"
              :before-upload="beforeAvatarUpload"
            >
            <div class="upload-image" :class="[{'image-active':formLabelAlign.raffleImage}]" v-if="formLabelAlign.raffleImage">
              <img :src="formLabelAlign.raffleImage"/>
            </div>
            <div class="upload-icon" v-else>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </div>
            <div class="el-upload__tip" slot="tip"> <i class="el-icon-info" />{{$t('passwordLuckDraws.支持文件')}}</div>
          </el-upload>
          <div class="upload-delete"  v-if="formLabelAlign.raffleImage">
            <span @click="handleRemove()"><i class="el-icon-delete"></i></span>
          </div>
        </el-form-item>
        <el-form-item :label="`${$t('passwordLuckDraws.抽奖')}：`">
          <el-switch v-model="formLabelAlign.needPassword" :width="28" active-color="#2081EB" inactive-color="#5B617E"></el-switch>
        </el-form-item>
        <el-form-item  v-if="formLabelAlign.needPassword" :label="$t('passwordLuckDraws.口令内容')" prop="password">
          <el-input
            v-model="formLabelAlign.password"
            class="luck-password"
            type="text"
            :placeholder="$t('passwordLuckDraws.请输入口令内容')"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item v-if="formLabelAlign.needPassword" :label="$t('passwordLuckDraws.提示')" prop="tips">
          <el-input
            v-model="formLabelAlign.tips"
            class="luck-tips"
            type="text"
            :placeholder="$t('passwordLuckDraws.输入口令，参与抽奖')"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('luckDraws.中奖信息采集')">
          <div class="form-item">
            <div class="flex-1">
              <el-switch v-model="gotMoreSet" :width="28" active-color="#2081EB" inactive-color="#5B617E">
              </el-switch>
            </div>
            <el-link v-if="gotMoreSet && formLabelAlign.winnerVerifyInfo.length <= 4" type="primary"
              @click="addMoreList()">{{ $t("luckDraws.添加自定义选项") }}</el-link>
          </div>
        </el-form-item>
        <div class="moreSet" v-if="gotMoreSet">
          <div v-for="(moreSet, index) in formLabelAlign.winnerVerifyInfo" :key="'morelist' + index">
            <div v-if="moreSet.type">
              <el-form-item :key="'morelist' + index" :prop="'winnerVerifyInfo.' + index + '.infoType'" :rules="formRules"
                :label="$t(`luckDraws.${moreSet.infoType}`)" :label-width="moreSet.type ? '120px' : '85px'">
                <div class="flex-box">
                  <el-input v-model="moreSet.remark" :placeholder="$t(`luckDraws.${moreSet.remark}`)" :maxlength="100"
                    class="flex-1" disabled />
                  <a class="icon el-icon-delete" :title="$t('luckDraws.删除选项')" href="javascript:;"
                    @click="keyDelete(index)"></a>
                </div>
              </el-form-item>
            </div>
            <div class="flex-box" v-else>
              <el-form-item :prop="'winnerVerifyInfo.' + index + '.infoType'" :rules="formRules" :label="''"
                :label-width="'85px'" class="flex-1">
                <el-input v-model="moreSet.infoType" :maxlength="10" class="moreListStart"
                  :placeholder="$t('luckDraws.请填写字段名')" @input="filterSpace(moreSet, 'infoType')" />
              </el-form-item>
              <el-form-item :prop="'winnerVerifyInfo.' + index + '.remark'" :rules="formRules" :label="''"
                :label-width="'0px'" class="flex-1">
                <el-input v-model="moreSet.remark" :maxlength="10" class="moreListLong"
                  :placeholder="$t('luckDraws.请填写提示语')" @input="filterSpace(moreSet, 'remark')" />
                <a class="icon el-icon-delete" :title="$t('luckDraws.删除选项')" href="javascript:;"
                  @click="keyDelete(index)"></a>
              </el-form-item>
            </div>
          </div>
        </div>
        <el-form-item :label="$t('luckDraws.中奖用户排除')" prop="winnerExclusion">
          <div class="form-item">
            <el-switch
              v-model="formLabelAlign.winnerExclusion"
              :width="28"
              active-color="#2081EB"
              inactive-color="#5B617E"
              @change="handleWinnerExclusionChange"
            >
            </el-switch>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="sign-btn">
        <div>
          <el-link type="primary" @click="setHistoryVisible(true)">
            {{ $t("luckDraws.抽奖记录") }}
          </el-link>
        </div>
        <div>
          <el-button :loading="isLoading" class="button-mini" type="primary" size="mini" @click="launchPasswordLuckDraws(true)">{{
            $t("luckDraws.开始抽奖") }}</el-button>
        </div>
      </div>
    </el-dialog>
    <PasswordLuckHistory :visible.sync="historyVisible" />
    <PasswordLuckDetail
      :visible.sync="luckDetailVisible"
      :raffleId="raffleId"
      :runningRaffleData="runningRaffleData"
      :luckAudienceVisible="luckAudienceVisible"
      :luckDetailSubmitCount="luckDetailSubmitCount"
      @setLuckAudienceVisible="setLuckAudienceVisible"
      @setLuckDetailVisible="setLuckDetailVisible"
      @setLuckedVisible="setLuckedVisible"
    />
    <PasswordLuckAudienceList
      :visible.sync="luckAudienceVisible"
      :raffleId="raffleId"
      :luckDetailSubmitCount="luckDetailSubmitCount"
      @setLuckDetailVisible="setLuckDetailVisible"
    />
    <PasswordLucked
      :visible.sync="luckedVisible"
      :raffleId.sync="raffleId"
      :config="config"
      @reluck="reluck"
    />
  </div>
</template>

<script>
import {
  Autocomplete,
  Dialog,
  Form,
  FormItem,
  Link,
  Popover,
  Switch,
  Tag,
  Tooltip,
} from "element-ui";
import PasswordLuckHistory from "./password-luck-history.vue";
import PasswordLucked from "./password-lucked.vue";
import PasswordLuckDetail from "./password-luck-detail.vue";
import PasswordLuckAudienceList from "./password-luck-audience-list.vue";
import { mapGetters } from "vuex";
import { getCursorIndex, getParameter } from "@/utils/global";
import { pushRoomMessageFunc, removeMessageFunc } from "@/utils/socketMessageDispose";
import {
  // getLuckCount,
  startLuckDraw,
  getRunningPasswordRaffle,
  cancelPasswordRaffle,
  getPasswordRaffleSubmitCount
} from "@/api/liveRequest/luckDawApi";

const MAX_WINNER_NUMBER = 500; // 最大中间人数
let runningPasswordRaffleSeq = 0;

export default {
  components: {
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Link.name]: Link,
    [Autocomplete.name]: Autocomplete,
    [Switch.name]: Switch,
    [Tag.name]: Tag,
    [Popover.name]: Popover,
    [Tooltip.name]: Tooltip,
    PasswordLuckHistory,
    PasswordLucked,
    PasswordLuckDetail,
    PasswordLuckAudienceList
  },
  data() {
    var validatorNull = (rule, value, callback) => {
      value = value.trim();
      if (value == null || value == "" || value == undefined) {
        if (rule.field.endsWith(".remark")) {
          callback();
        } else {
          callback(new Error(this.$t("luckDraws.请输入字段名")));
        }
      } else {
        callback();
      }
    };

    return {
      gotMoreSet: false,
      formLabelAlign: {
        webcastId: null, //场次id
        subject: this.$t("passwordLuckDraws.猜口令赢大奖"),
        title: "", //抽奖标题
        candidatesRange: "7",
        candidatesUserId: [], //预设人列表
        candidatesUsers: [],
        raffleCount: "", //中奖人数
        needCheck: true, //自动下发,默认是
        password: "", // 口令内容
        tips: "", // 口令提示
        winnerVerifyInfo: [
          {
            infoType: "姓名",
            remark: this.$t("luckDraws.请填写您的姓名"),
            type: 1,
          },
          {
            infoType: "手机",
            remark: this.$t("luckDraws.请填写您的手机"),
            type: 2,
          },
        ],
        winnerExclusion: true,
        rounds: "",
        drawCountdownDateJson: {
          hour: '',
          minutes: '',
          seconds: ''
        },
        raffleDuration: {
          hour: 0,
          minutes: 0,
          seconds: 0,
        },
        autoDraw: true,
        needPassword: false,
        raffleImage: ''
      },
      formRules: {
        validator: validatorNull,
        trigger: "blur",
      },
      raffleId: "", // 抽奖id
      historyVisible: false, // 抽奖历史弹窗
      luckDetailVisible: false, // 抽奖详情弹窗
      luckAudienceVisible: false, // 抽奖观众列表弹窗
      luckedVisible: false, // 中奖弹窗
      runningRaffleData: undefined, // 已经存在的运行中的抽奖结果
      isInitDataing: false, // 是否初始化数据中
      // total: 0, // 参与用户人数
      liveId: getParameter("liveId"),
      isFoucs: false,
      lucks: ["特等奖", "一等奖", "二等奖", "三等奖", "阳光普照奖"],
      isLoading: false,
      config: {},
      luckDetailSubmitCount: 0, // 抽奖详情: 参与人数
      dataObj: {
        siteId: ""
      },
      uploadUrl: `${window.config.uploadUrl}/info/upload/deal`
    };
  },
  watch: {
    isShowPasswordLuck: {
      handler() {
        if (this.$store.getters.isShowPasswordLuck) {
          this.isInitDataing = true;
          this.runningRaffleData = undefined;
          this.raffleId = undefined;

          const runningPasswordRaffleSeqTmp = ++runningPasswordRaffleSeq;
          getRunningPasswordRaffle()
            .then((res) => {
              if (!this.$store.getters.isShowPasswordLuck || runningPasswordRaffleSeqTmp !== runningPasswordRaffleSeq)
                return;

              this.isInitDataing = false;

              if (res.code === 200 && res.data.length) {
                if (res.data.length > 1) {
                  // 多个正在运行中的口令抽奖，需要取消旧的
                  for (let i=0; i < res.data.length-1; i++) {
                    const oldRunningPasswordRaffle = res.data[i];
                    console.warn('watch isShowPasswordLuck oldRunningPasswordRaffle:', JSON.stringify(oldRunningPasswordRaffle));
                    cancelPasswordRaffle({raffleId: oldRunningPasswordRaffle.id})
                  }
                }

                const runningRaffleData = res.data[res.data.length -1];
                console.log('watch isShowPasswordLuck set runningRaffleDataStr:', JSON.stringify(runningRaffleData));

                if (this.raffleId !== runningRaffleData.id) {
                  this.raffleId = runningRaffleData.id;
                  this.luckDetailSubmitCount = 0;
                }
     
                this.runningRaffleData = runningRaffleData;
                this.setLuckDetailVisible(true);
                this.$store.commit("SET_SHOW_PASSWORD_LUCK", false);
              }
            }).catch((err) => {
              if (!this.$store.getters.isShowPasswordLuck || runningPasswordRaffleSeqTmp !== runningPasswordRaffleSeq)
                return;

              console.error('watch isShowPasswordLuck getRunningPasswordRaffle catch err:', err);
              this.isInitDataing = false;
              this.luckDetailSubmitCount = 0;
            });
        } else {
          this.isInitDataing = false;
        }
      }
    }
  },
  beforeDestroy() {
    removeMessageFunc(this.getCvMcRoomMessage);
  },
  mounted() {
    pushRoomMessageFunc(this.getCvMcRoomMessage);
  },
  computed: {
    ...mapGetters([
      "isShowPasswordLuck",
      "all_user_online_count",
      "liveToken",
      "liveRoomStatus",
    ]),
    rules() {
      var checkLuckCount = (rule, value, callback) => {
        console.log('checkLuckCount value', value, typeof value, this.formLabelAlign.raffleCount, typeof this.formLabelAlign.raffleCount);
        // if (value > this.total) {
        //   callback(new Error(this.$t("luckDraws.中奖人数不能超过参与用户人数")));
        // } else if (value < 1) {
        const valueTmp = Number(this.formLabelAlign.raffleCount);
        if (!valueTmp || isNaN(valueTmp) || valueTmp < 1) {
          this.formLabelAlign.raffleCount = "";
          callback(new Error(this.$t("luckDraws.请输入中奖人数")));
        } else if (valueTmp > 500) {
          callback(new Error(`${this.$t("passwordLuckDraws.中奖人数不能超过")}${MAX_WINNER_NUMBER}`));
        } else {
          callback();
        }
      };

      var checkCountdown  = (rule, value, callback) => {
        console.log('checkCountdown value', value, typeof value, JSON.stringify(this.formLabelAlign.drawCountdownDateJson));
        if(this.formLabelAlign.autoDraw){
        const {hour: hourStr, minutes: minutesStr, seconds: secondsStr} = this.formLabelAlign.drawCountdownDateJson;
        const hour = !hourStr ? 0 : Number(hourStr);
        const minutes = !minutesStr ? 0 : Number(minutesStr);
        const seconds = !secondsStr ? 0 : Number(secondsStr);
        const totalSec = hour * 60 * 60 + minutes * 60 + seconds;

        if (hour > 0 || seconds >59 || minutes > 59 || totalSec > (59 * 60 + 59) || totalSec < 10) {
          callback(new Error(this.$t("passwordLuckDraws.请输入范围内的时间")));
          return;
        }
        callback();
        }else {
          callback();
        }
      };

      return {
        subject: [
          {
            required: true,
            message: this.$t("passwordLuckDraws.请输入抽奖标题"),
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: this.$t("luckDraws.请输入奖品名称"),
            trigger: "blur",
          },
        ],
        raffleCount: [
          {
            required: true,
            message: this.$t("luckDraws.请输入中奖人数"),
            trigger: "blur",
          },
          { validator: checkLuckCount, trigger: "blur" },
        ],
        countdown: [
          { validator: checkCountdown, trigger: "blur" },
        ],
        password: [
          {
            required: true,
            message: this.$t("passwordLuckDraws.请输入口令内容"),
            trigger: "blur",
          },
        ],
        winnerVerifyInfo: []
      };
    },
    labelWidth() {
      if (this.$i18n.locale === "en-US") {
        return "";
      } else {
        return "95px";
      }
    },
  },
  methods: {
    /**
     * 删除图片
     * @param e 
     */
    handleRemove(e){
      this.formLabelAlign.raffleImage = "";
      e.stopPropagation();
    },
    /**
     * 检查文件类型
     * @param file 
     */
    beforeAvatarUpload(file) {
      if (["image/jpeg", "image/jpg", "image/png"].indexOf(file.type) == -1) {
        this.$message.error(`${this.$t('passwordLuckDraws.图片格式错误')}`);
        return false
      }
      const isLt2M = file.size / 1024 < 100;
      if (!isLt2M) {
        this.$message.error(`${this.$t('passwordLuckDraws.图片大小超过2M')}`);
        return false
      }
    },
    /**
     * 文件上传成功
     * @param res 
     */
    uploadSuccess(res) {
      if (res.code === 0) {
        this.formLabelAlign.raffleImage = res.data[1];
      } else {
        this.$message.error(`${this.$t('passwordLuckDraws.上传图片失败')}`);
      }
    },
    initFormLabelAlign () {
      this.formLabelAlign.subject =  this.$t("passwordLuckDraws.猜口令赢大奖");
      this.formLabelAlign.title = '';
      this.formLabelAlign.raffleCount = '';
      this.formLabelAlign.drawCountdownDateJson.hour = '';
      this.formLabelAlign.drawCountdownDateJson.minutes = '';
      this.formLabelAlign.drawCountdownDateJson.seconds = '';
      this.formLabelAlign.password = '';
      this.formLabelAlign.tips = '';
      this.formLabelAlign.winnerVerifyInfo = [
        {
          infoType: "姓名",
          remark: this.$t("luckDraws.请填写您的姓名"),
          type: 1,
        },
        {
          infoType: "手机",
          remark: this.$t("luckDraws.请填写您的手机"),
          type: 2,
        },
      ];
      this.formLabelAlign.winnerExclusion = true;
    },
    onOpen() {
      this.initFormLabelAlign();
      // this.getPasswordLuckCount();
    },
    handleWinnerExclusionChange() {
      // this.getPasswordLuckCount();
    },
    getCvMcRoomMessage(msg) {
      switch (msg.cmd) {
        case 7107: {
          let _requestData = msg.requestData;

          if (_requestData.event === 'raffle/cancel') { // 取消抽奖通知
            if (!this.raffleId || `${_requestData.raffleId}` !== `${this.raffleId}`)
              return;

            this.hideAllExtraLuckVisible();
          }
          break;
        }
        case 7127: {
          let _requestData = msg.requestData;

          if (_requestData.event === 'raffle/draw') { // 自动/手动开奖通知
            if (!this.raffleId || `${_requestData.raffleId}` !== `${this.raffleId}`)
              return;

            this.hideAllExtraLuckVisible({luckedVisible: true});
            this.setLuckedVisible(true);
          }

          if (_requestData.event === 'raffle/submit') { // 参与人数通知
            if (!this.raffleId || `${_requestData.raffleId}` !== `${this.raffleId}`)
              return;

            this.luckDetailSubmitCount = _requestData.count;
          }
          break;
        }
      }
    },
    setFast(text) {
      const content = this.formLabelAlign.title;
      if ((content + text).length >= 30) return;
      const index = getCursorIndex(this.$refs.input?.$refs?.input);
      if (typeof index === "number") {
        const arr = content.split("");
        arr.splice(index, 0, text);
        this.formLabelAlign.title = arr.join("");
      } else {
        this.formLabelAlign.title = content + text;
      }
      this.checkRule("title");
    },
    // 发起抽奖
    launchPasswordLuckDraws() {
      this.needLoading = true;
      if (this.liveRoomStatus != 2) {
        return this.$message.warning(this.$t("luckDraws.请先开启直播"));
      }
      
      this.$refs.passwordLuckDraw.validate((valid) => {
        if (valid) {
          this.start();
        } else {
          console.log("launchPasswordLuckDraws validate not valid this.formLabelAlign", JSON.stringify(this.formLabelAlign));
        }
      });
    },
    start() {
      this.isLoading = this.needLoading;
      console.log("start this.formLabelAlign", JSON.stringify(this.formLabelAlign));

      const config = Object.assign({}, JSON.parse(JSON.stringify(this.formLabelAlign)), {
        webcastId: this.$route.params.liveId,
      });
      if (!this.gotMoreSet) {
        delete config.winnerVerifyInfo;
      }

      //! 临时为了解决candidatesUsers莫名会多出一个空字符串的问题
      config.candidatesUsers = config.candidatesUsers.filter(element => element !== null && element !== "");
      //! 某些情况下needCheck会被改成[]导致抽奖接口报错，临时先增加类型判断，如果类型不是布尔值，强制改回布尔值
      if ('needCheck' in config && typeof config.needCheck !== "boolean") {
        config.needCheck = false;
      }

      const drawCountdownDateJson = config.drawCountdownDateJson;
      delete config.drawCountdownDateJson;
      drawCountdownDateJson.hour = Number(drawCountdownDateJson.hour || '00') || 0;
      drawCountdownDateJson.minutes = Number(drawCountdownDateJson.minutes || '00') || 0;
      drawCountdownDateJson.seconds = Number(drawCountdownDateJson.seconds || '00') || 0;

      config.drawCountdown = (drawCountdownDateJson.hour * 60 * 60) + (drawCountdownDateJson.minutes * 60) + drawCountdownDateJson.seconds;

      if (!config.tips)
        config.tips = this.$t('passwordLuckDraws.输入口令，参与抽奖');

      startLuckDraw(config)
        .then(async (res) => {
          if (res?.code == 200 && res.data?.raffleId) {
            this.onResult(res.data.raffleId);
          } else {
            this.$message.error(res.msg)
            //this.onResult(null);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // 添加自定义选项 最多只能添加5个
    addMoreList() {
      this.formLabelAlign.winnerVerifyInfo.push({
        infoType: "",
        remark: "",
      });
    },
    // 删除用户信息采集
    keyDelete(index) {
      this.formLabelAlign.winnerVerifyInfo.splice(index, 1);
    },
    // 过滤空格
    filterSpace(info, type) {
      info[type] = info[type].trim();
    },
    onResult(prevId) {
      this.config = Object.assign({}, this.formLabelAlign);
      this.formLabelAlign.candidatesUserId = [];
      const raffleId = prevId;
      this.raffleId = raffleId;
      this.luckDetailSubmitCount = 0;
      this.runningRaffleData = undefined;
      this.setLuckDetailVisible(false);

      if (!raffleId) {
        this.$store.commit("SET_SHOW_PASSWORD_LUCK", false);
        return;
      }

      const runningPasswordRaffleSeqTmp = ++runningPasswordRaffleSeq;
      getRunningPasswordRaffle()
        .then((res) => {
          if (!this.isShowPasswordLuck || runningPasswordRaffleSeqTmp !== runningPasswordRaffleSeq || raffleId !== this.raffleId)
            return;

          if (res.code === 200 && res.data.length) {
            if (res.data.length > 1) {
              // 多个正在运行中的口令抽奖，需要取消旧的
              for (let i=0; i < res.data.length-1; i++) {
                const oldRunningPasswordRaffle = res.data[i];
                console.warn('startLuckDraw onResult oldRunningPasswordRaffle:', JSON.stringify(oldRunningPasswordRaffle));
                cancelPasswordRaffle({raffleId: oldRunningPasswordRaffle.id})
              }
            }

            const runningRaffleData = res.data[res.data.length -1];
            console.log('startLuckDraw onResult set runningRaffleDataStr:', JSON.stringify(runningRaffleData));

            this.runningRaffleData = runningRaffleData;
            this.setLuckDetailVisible(true);
            this.$store.commit("SET_SHOW_PASSWORD_LUCK", false);
          } else {
            this.setLuckDetailVisible(false);
            //this.$store.commit("SET_SHOW_PASSWORD_LUCK", false);
          }
        }).catch((err) => {
          if (!this.isShowPasswordLuck || runningPasswordRaffleSeqTmp !== runningPasswordRaffleSeq)
            return;

          console.error('startLuckDraw onResult getRunningPasswordRaffle catch err:', err);
          this.setLuckDetailVisible(false);
          //this.$store.commit("SET_SHOW_PASSWORD_LUCK", false);
        });
    },
    checkRule(name) {
      this.$refs.passwordLuckDraw?.validateField(name);
    },
    close() {
      this.$refs.passwordLuckDraw.resetFields();
      this.formLabelAlign.winnerVerifyInfo = [
        {
          infoType: "姓名",
          remark: this.$t("luckDraws.请填写您的姓名"),
          type: 1,
        },
        {
          infoType: "手机",
          remark: this.$t("luckDraws.请填写您的手机"),
          type: 2,
        },
      ];
      this.gotMoreSet = false;
      this.$store.commit("SET_SHOW_PASSWORD_LUCK", false);
    },
    reluck() {
      this.runningRaffleData = undefined;
      this.raffleId = undefined;
      this.formLabelAlign.raffleImage = '';
      this.hideAllExtraLuckVisible(false);
      this.$store.commit("SET_SHOW_PASSWORD_LUCK", true);
    },
    setLuckDetailVisible(isVisible) {
      this.luckDetailVisible = !!isVisible;
      this.setLuckAudienceVisible(false);

      if (this.luckDetailVisible && !this.luckDetailSubmitCount) {
        getPasswordRaffleSubmitCount(this.raffleId).then((res) => {
          if (!this.luckDetailVisible || res.code !== 200 || this.luckDetailSubmitCount)
            return;
          
          this.luckDetailSubmitCount = res.data;
        });
      }
    },
    setLuckAudienceVisible (isVisible) {
      this.luckAudienceVisible = isVisible;
    },
    setLuckedVisible (isVisible) {
      this.luckedVisible = isVisible;
    },
    setHistoryVisible (isVisible) {
      this.historyVisible = isVisible;
    },
    hideAllExtraLuckVisible (ignoreJson={}) {
      !ignoreJson.luckDetailVisible && this.setLuckDetailVisible(false);
      !ignoreJson.luckAudienceVisible && this.setLuckAudienceVisible(false);
      !ignoreJson.listoryVisible && this.setHistoryVisible(false);
      !ignoreJson.luckedVisible && this.setLuckedVisible(false);
    }
    // async getPasswordLuckCount() {
    //   const { code, data } = await getLuckCount({
    //     webcastId: this.liveId,
    //     candidatesRange: 0,
    //     winnerExclusion: this.formLabelAlign.winnerExclusion,
    //     rounds: this.formLabelAlign.rounds,
    //   });

    //   if (code === 200) {
    //     this.total = data;
    //     if (this.formLabelAlign.raffleCount !== undefined && this.formLabelAlign.raffleCount !== '') {
    //       this.checkRule('raffleCount');
    //     }
    //   }
    // }
  },
};
</script>
<style scoped lang="scss">
.passwordLuckDraw {
  margin-left: 100px;
  margin-top: 40px;
  text-align: left;

  &[data-i18n-locale="en-US"] {
    ::v-deep  .el-form-item {
      display: flex;

      .el-form-item__content {
        flex: 1;
      }
    }
  }
}

.moreListStart {
  width: 139px;
}

.moreListLong {
  width: 139px;
  margin-left: 10px;
}

.btn-blue-outline {
  border-radius: 4px;
}

.sign-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.link-blue {
  color: #2081eb;
  text-decoration: none;
}

.link-blue:hover {
  text-decoration: underline;
}

.luck_moreSet {
  margin-left: 40px;
}

.el-form-item__content .icon {
  width: 18px;
  height: 28px;
  line-height: 28px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  color: #ea494b;
  text-decoration: none;
}

.input-ground .input-titles {
  display: inline-block;
  text-align: right;
  width: 170px;
}

.form-item {
  height: 28px;
  line-height: 1;
  display: flex;
  align-items: center;

  .el-link {
    font-size: 12px;
  }
}

.luck-num {
  .el-input {
    width: 136px;
    // width: 55px;
  }

  &-tip {
    font-size: 12px;
    margin-left: 12px;
  }
}

.input-tip {
  font-size: 12px;
  margin-left: 12px;
}

.luck-countdown {
  color: #727480;

  ::v-deep .el-input {
    width: 40px;

    .el-input__inner {
      text-align: center;
    }
  }

  .colon {
    text-align: center;
    display: inline-block;
    padding: 0px 8px;
  }
}

.password-luck-fastbox {
  display: flex;
  justify-content: space-between;

  >div {
    height: 34px;
    line-height: 32px;
    padding: 0 7px;
    border: 1px solid #444767;
    font-size: 12px;
    text-align: center;
    background: #202341;
    border-radius: 3px;
    box-sizing: border-box;
    cursor: pointer;
  }
}

.auto-input {
  width: 100%;
}


</style>

<style lang="scss">
.password-luck {
  .required {
    color: #F56C6C;
    margin-left: 4px;
  }

  .el-dialog__body {
    padding-right: 32px;
  }

  .el-select {
    width: 190px;
  }

  .el-input--mini .el-input__inner {
    padding: 0 8px;
    color: #fff;
    border-color: #525366;
  }

  .el-form-item--mini .el-form-item__error {
    padding-top: 4px;
  }

  .el-input--mini .el-input__inner[maxlength] {
    padding-right: 50px;
    border-color: #525366;
  }


  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  .el-tag.el-tag--info {
    background-color: #212442;
    border-color: #acb2bf;
    color: #acb2bf;
  }
}

.luck-num {
  .el-input__inner {
    color: #fff;
    border-color: #525366;
  }
}

.luck-tip-popconfirm {
  padding: 10px;
  box-sizing: border-box;

  .popper__arrow {
    left: 20px !important;
  }
}
.upload-image {
	width: 98px;
	height: 98px;
	position: relative;
	img {
		max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
    object-fit: fill;
	}
}
.upload-delete{
  position:absolute;
  bottom: 30px;
  left: 81px;
  width: 28px;
  height:28px;
  line-height:28px;
  cursor:pointer;
}
.el-upload--picture-card{
  width: 100px;
  height: 100px;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
